import api from './api';

export interface ProviderCredentials {
  provider: string;
  keys: string[];
}

export interface CredentialEntry {
  key: string;
  value: string;
}

export interface CredentialSetRequest {
  provider: string;
  credentials: CredentialEntry[];
}

export const credentialService = {
  /** List all providers and their key names (values are never returned). */
  list: async (): Promise<ProviderCredentials[]> => {
    const response = await api.get<ProviderCredentials[]>('/credentials');
    return response.data;
  },

  /** Upsert all credential keys for a provider (replaces existing). */
  set: async (data: CredentialSetRequest): Promise<void> => {
    await api.put('/credentials', data);
  },

  /** Delete all credentials for a provider. */
  deleteProvider: async (provider: string): Promise<void> => {
    await api.delete(`/credentials/${encodeURIComponent(provider)}`);
  },
};
